import { useI18n } from '@cascade/react/i18n';
import { Button, Dialog, Text, TextArea } from '@cascade/ui-library';
import { useState } from 'react';
import classes from './FeedbackDialog.module.scss';
import type { TFeedbackDialogProps } from './FeedbackDialog.types.ts';

export const FeedbackDialog = ({
  type,
  isReasonRequired,
  isSending = false,
  errorMessage,
  onSubmit,
  onClose,
}: TFeedbackDialogProps) => {
  const { translate } = useI18n();
  const [reason, setReason] = useState('');

  const trimmedReason = reason.trim();
  const isReasonMissing = isReasonRequired && !trimmedReason;

  const submit = () => onSubmit(trimmedReason);

  return (
    <Dialog
      open
      size='sm'
      title={translate(`agent.feedback.${type}.title`)}
      subtitle={translate(`agent.feedback.${type}.description`)}
      closeLabel={translate('agent.feedback.close')}
      className={classes.content}
      dismissible={!isSending}
      footer={
        <div className={classes.actions}>
          <Button
            variant='secondary'
            label={translate('agent.feedback.cancel')}
            disabled={isSending}
            onClick={onClose}
          />
          <Button
            variant='primary'
            label={translate('agent.feedback.submit')}
            disabled={isSending || isReasonMissing}
            onClick={submit}
          />
        </div>
      }
      onClose={onClose}
    >
      <TextArea
        label={translate('agent.feedback.reason')}
        placeholder={translate('agent.feedback.placeholder')}
        value={reason}
        rows={4}
        required={isReasonRequired}
        disabled={isSending}
        onChange={setReason}
      />
      {errorMessage ? (
        <Text
          type='caption'
          color='text-danger'
          role='alert'
          content={errorMessage}
        />
      ) : null}
    </Dialog>
  );
};
